/** Add autocomplete values to inputs for ADA. */
const inputElements = [...document.querySelectorAll('input')];

if (inputElements.length !== 0) {
  inputElements.forEach((inputElement) => {
    inputElement.removeAttribute('autocomplete');
    const placeholderText = inputElement.getAttribute('placeholder');

    if (inputElement.type === 'email') {
      inputElement.setAttribute('autocomplete', 'email');
    } else if (inputElement.type === 'text') {
      if (placeholderText === 'First Name') {
        inputElement.setAttribute('autocomplete', 'given-name');
      } else if (placeholderText === 'Last Name') {
        inputElement.setAttribute('autocomplete', 'family-name');
      } else if (placeholderText === 'Address Line 1') {
        inputElement.setAttribute('autocomplete', 'address-line1');
      } else if (placeholderText === 'Address Line 2') {
        inputElement.setAttribute('autocomplete', 'address-line2');
      } else if (placeholderText === 'City') {
        inputElement.setAttribute('autocomplete', 'address-level2');
      } else if (placeholderText) {
        inputElement.setAttribute('autocomplete', placeholderText.replace(/\s/g, '-'));
      }
    }
  });
}
